import { c as _c } from "react/compiler-runtime";
import type { Playbook } from '@onefootprint/request-types/dashboard';
import { Table as UITable } from '@onefootprint/ui';
import { useSearchParams } from 'next/navigation';
import { useTranslation } from 'react-i18next';
import type z from 'zod';
import useMobileLayout from '@/hooks/use-mobile-layout';
import { useOpenPage } from '@/hooks/use-open-page';
import usePlaybooksQueryParams from '../hooks/use-playbooks-query-params';
import type { tabsRouterSchema } from '../schema';
import Filters from './components/filters';
import MobileRow from './components/mobile-row';
import Row from './components/row';
type TableProps = {
  data?: Playbook[];
  errorMessage?: string;
  isPending?: boolean;
};
const Table = t0 => {
  const $ = _c(60);
  const {
    data,
    isPending,
    errorMessage
  } = t0;
  const {
    t
  } = useTranslation("playbooks");
  const handleOpenPage = useOpenPage();
  const searchParams = useSearchParams();
  const queryParams = usePlaybooksQueryParams();
  const isMobile = useMobileLayout();
  let t1;
  if ($[0] !== t) {
    t1 = t(_temp);
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = {
      id: "name",
      text: t1,
      width: "25%"
    };
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t) {
    t3 = t(_temp2);
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = {
      id: "type",
      text: t3,
      width: "10%"
    };
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t) {
    t5 = t(_temp3);
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t5) {
    t6 = {
      id: "key",
      text: t5,
      width: "30%"
    };
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t) {
    t7 = t(_temp4);
    $[12] = t;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t7) {
    t8 = {
      id: "status",
      text: t7,
      width: "15%"
    };
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t) {
    t9 = t(_temp5);
    $[16] = t;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t9) {
    t10 = {
      id: "edited",
      text: t9,
      width: "15%"
    };
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      id: "actions",
      text: "",
      width: "5%"
    };
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t10 || $[22] !== t2 || $[23] !== t4 || $[24] !== t6 || $[25] !== t8) {
    t12 = [t2, t4, t6, t8, t10, t11];
    $[21] = t10;
    $[22] = t2;
    $[23] = t4;
    $[24] = t6;
    $[25] = t8;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  const columns = t12;
  let t13;
  if ($[27] !== t) {
    t13 = t(_temp6);
    $[27] = t;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== t13) {
    t14 = {
      id: "name",
      text: t13
    };
    $[29] = t13;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = {
      id: "actions",
      text: "",
      width: "68px"
    };
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== t14) {
    t16 = [t14, t15];
    $[32] = t14;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  const mobileColumns = t16;
  let t17;
  if ($[34] !== queryParams) {
    t17 = search => {
      queryParams.push({
        search,
        page: undefined
      });
    };
    $[34] = queryParams;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  const handleSearchChange = t17;
  let t18;
  if ($[36] !== handleOpenPage || $[37] !== searchParams) {
    t18 = (playbook, event) => {
      const path = `/playbooks/${playbook.publishedVersion.playbookId}`;
      const query = {
        ...Object.fromEntries(searchParams.entries()),
        tab: "data"
      };
      handleOpenPage(event, path, query);
    };
    $[36] = handleOpenPage;
    $[37] = searchParams;
    $[38] = t18;
  } else {
    t18 = $[38];
  }
  const handleRowClick = t18;
  let t19;
  if ($[39] !== errorMessage || $[40] !== queryParams.values.search || $[41] !== t) {
    t19 = () => {
      if (errorMessage) {
        return errorMessage;
      }
      return queryParams.values.search ? t(_temp7) : t(_temp8);
    };
    $[39] = errorMessage;
    $[40] = queryParams.values.search;
    $[41] = t;
    $[42] = t19;
  } else {
    t19 = $[42];
  }
  const getEmptyStateText = t19;
  let t20;
  if ($[43] !== t) {
    t20 = t(_temp9);
    $[43] = t;
    $[44] = t20;
  } else {
    t20 = $[44];
  }
  const t21 = isMobile ? mobileColumns : columns;
  let t22;
  if ($[45] !== getEmptyStateText) {
    t22 = getEmptyStateText();
    $[45] = getEmptyStateText;
    $[46] = t22;
  } else {
    t22 = $[46];
  }
  let t23;
  if ($[47] !== isMobile) {
    t23 = t24 => {
      const {
        item: playbook_2
      } = t24;
      return isMobile ? <MobileRow playbook={playbook_2} /> : <Row playbook={playbook_2} />;
    };
    $[47] = isMobile;
    $[48] = t23;
  } else {
    t23 = $[48];
  }
  let t24;
  if ($[49] !== data || $[50] !== handleRowClick || $[51] !== handleSearchChange || $[52] !== isMobile || $[53] !== isPending || $[54] !== queryParams.values.search || $[55] !== t20 || $[56] !== t21 || $[57] !== t22 || $[58] !== t23) {
    t24 = <UITable aria-label={t20} columns={t21} emptyStateText={t22} getAriaLabelForRow={_temp10} getKeyForRow={_temp11} hideThead={isMobile} initialSearch={queryParams.values.search} isLoading={isPending} items={data} onChangeSearchText={handleSearchChange} onRowClick={handleRowClick} renderActions={_temp12} renderTr={t23} />;
    $[49] = data;
    $[50] = handleRowClick;
    $[51] = handleSearchChange;
    $[52] = isMobile;
    $[53] = isPending;
    $[54] = queryParams.values.search;
    $[55] = t20;
    $[56] = t21;
    $[57] = t22;
    $[58] = t23;
    $[59] = t24;
  } else {
    t24 = $[59];
  }
  return t24;
};
export default Table;
function _temp($) {
  return $.table.header.name;
}
function _temp2($_0) {
  return $_0.table.header.type;
}
function _temp3($_1) {
  return $_1.table.header.key;
}
function _temp4($_2) {
  return $_2.table.header.status;
}
function _temp5($_3) {
  return $_3.table.header.edited;
}
function _temp6($_4) {
  return $_4.table.header.name;
}
function _temp7($_5) {
  return $_5.noResultsDescription;
}
function _temp8($_6) {
  return $_6.emptyDescription;
}
function _temp9($_7) {
  return $_7.table.ariaLabel;
}
function _temp10(playbook_0) {
  return playbook_0.publishedVersion.name;
}
function _temp11(playbook_1) {
  return playbook_1.id;
}
function _temp12() {
  return <Filters />;
}